export default "__VITE_ASSET__CKDCwq0Q__"